import React, { useMemo } from 'react';
import { Grid, GridProps, TextField, TextFieldProps } from '@material-ui/core';

export type EmailFields = {
  [key: string]: string | boolean | undefined;
  emailAddress?: string | undefined;
  isPrimary?: boolean;
  id?: string; // Note: ID is only used for frontend development
};

export type EmailFieldProps = {
  ContainerComponentProps?: GridProps;
  EmailFieldProps?: TextFieldProps;
  value?: EmailFields;
  onChange: (value: EmailFields) => void;
  onBlur?: (value: EmailFields) => void;
  error?: string | undefined;
};

export const EmailField = ({
  ContainerComponentProps,
  EmailFieldProps,
  value: valueProp,
  error,
  onChange,
  onBlur,
}: EmailFieldProps): JSX.Element => {
  const EmailAddressName = EmailFieldProps?.name || 'emailAddress';

  const state = useMemo(
    () =>
      valueProp || {
        [EmailAddressName]: '',
        isPrimary: false,
      },
    [valueProp],
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newState = { ...state, [name]: value };

    updateState(newState);
  };

  const handleBlur = () => {
    onBlur?.(state);
  };

  const updateState = (state: EmailFields) => {
    onChange?.(state);
  };

  return (
    <Grid container {...ContainerComponentProps}>
      <Grid item xs>
        <TextField
          inputProps={{ 'data-testid': 'email-field-input' }}
          data-testid="email-field-textfield"
          {...EmailFieldProps}
          fullWidth
          onChange={handleChange}
          onBlur={handleBlur}
          name={EmailAddressName}
          value={state[EmailAddressName]}
          error={!!error}
          helperText={error}
        />
      </Grid>
    </Grid>
  );
};

export default EmailField;
